import React from "react";
import { TextInput, TextInputProps, useMantineTheme } from "@mantine/core";

interface CustomInputProps extends Omit<TextInputProps, "styles"> {}

/**
 * Input - Themed text input component
 * Usage: <Input label="Name" placeholder="Enter your name" />
 */
export const Input: React.FC<CustomInputProps> = ({ ...props }) => {
  const theme = useMantineTheme();
  const other = theme.other as Record<string, string>;

  return (
    <TextInput
      {...props}
      styles={{
        label: {
          color: other.textPrimary,
          marginBottom: "0.5rem",
          fontWeight: 500,
        },
        input: {
          backgroundColor: "rgba(26, 20, 16, 0.85)",
          border: "1px solid rgba(245, 238, 224, 0.15)",
          color: other.textPrimary,
          "&:focus": {
            borderColor: other.focusRingColor,
            boxShadow: other.focusRing,
          },
          "&::placeholder": {
            color: other.placeholderText,
          },
        },
        error: {
          color: other.errorText,
        },
      }}
    />
  );
};

export default Input;
